import { createUniqueLocalStorageKey } from "../utils/basic-only";
import { SiteData } from "./types";

export const siteData = window.siteData as SiteData;

export const zIndex = {
    autocompleteResults: 1,
    scrollToTop: 25,
    navWrapper: 50,
    feedbackButton: 75,
    pwaInstallPrompt: 80,
    mobileMenu: 100,
    modal: 500,
    nProgress: 10001,
    loader: 10002,
};

export const siteId = siteData.installPath.replace(/\//g, "") || "testing";

export const persistedSuburbInformationKey = createUniqueLocalStorageKey("suburb-information");
